import Link from 'next/link';

interface MinFooterProps {
  className?: string;
}

const MinFooter = ({ className }: MinFooterProps) => {
  return (
    <p className={`text-xs cursor-pointer hover:underline ${className || ''}`}>
      <Link href='/policies'>Privacy & Usage Policies</Link>
    </p>
  );
};

export default MinFooter;
